import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listBuilderTemplates } from "../api/templateBuilderApi";

export default function TemplatesPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);
        setError("");
        const data = await listBuilderTemplates();
        setTemplates(data);
      } catch (err) {
        setError(err?.response?.data?.message || err?.message || "Templates laden mislukt");
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  const filtered = useMemo(() => {
    const needle = String(search || "").trim().toLowerCase();
    if (!needle) return templates;
    return templates.filter((item) => {
      const haystack = `${item?.name || ""} ${item?.type || ""} ${item?.category || ""}`.toLowerCase();
      return haystack.includes(needle);
    });
  }, [templates, search]);

  return (
    <div className="mx-auto max-w-6xl space-y-4 p-4 md:p-6">
      <section className="rounded-xl border bg-white p-5 shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Templates</h1>
            <p className="mt-1 text-sm text-gray-600">Bouw inspectie- en survey templates met drag and drop.</p>
          </div>
          <button
            type="button"
            onClick={() => navigate("/template-builder/new")}
            className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Nieuwe template
          </button>
        </div>
      </section>

      <section className="rounded-xl border bg-white p-5 shadow-sm">
        <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Zoek templates"
            className="w-full max-w-sm rounded border border-gray-300 px-3 py-2 text-sm"
          />
          <span className="text-xs text-gray-500">{filtered.length} templates</span>
        </div>

        {loading && <p className="text-sm text-gray-500">Laden...</p>}
        {error && <p className="text-sm text-red-600">{error}</p>}

        {!loading && !error && filtered.length === 0 && (
          <p className="text-sm text-gray-500">Geen templates gevonden.</p>
        )}

        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {filtered.map((template) => (
            <article key={template._id} className="rounded-lg border border-gray-200 bg-white p-4">
              <p className="text-xs uppercase tracking-wide text-gray-500">{template.type || "-"}</p>
              <h2 className="mt-1 text-base font-semibold text-gray-900">{template.name || "-"}</h2>
              <p className="mt-1 text-xs text-gray-600">Categorie: {template.category || "-"}</p>
              <p className="mt-1 text-xs text-gray-600">Status: {template.status || "-"}</p>
              <p className="mt-2 line-clamp-3 text-sm text-gray-700">{template.description || "Geen omschrijving"}</p>

              <div className="mt-3 flex gap-2">
                <button
                  type="button"
                  onClick={() => navigate(`/template-builder/${template._id}`)}
                  className="rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 hover:bg-gray-50"
                >
                  Open builder
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
